import React from "react";
import { Row, Col, Typography, List, Divider, Tooltip, Button, Popconfirm } from "antd";
import AdnList from "../common/adnList/AdnList";
import AdnCard from "../common/adnCard/AdnCard";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import {
  SolutionOutlined,
  ClockCircleOutlined,
  CalendarOutlined,
  GiftOutlined,
  TrophyOutlined,
} from "@ant-design/icons";
import { Eye, X, EyeOff } from "react-feather";
import InfiniteScroll from "react-infinite-scroll-component";
import adnYesNoModal from "../common/adnYesNoModal/AdnYesNoModal";
import { useNavigate } from "react-router-dom";
import "./NotificationListForm.css";

const NotificationTypes = {
  1: <CalendarOutlined />,
  2: <SolutionOutlined />,
  3: <GiftOutlined />,
  4: <ClockCircleOutlined />,
  5: <TrophyOutlined />,
  6: <SolutionOutlined />,
  7: <CalendarOutlined />,
};

export const NotificationListForm = ({
  title,
  notifications,
  loadMore,
  totalRecords,
  toggleIsRead,
  handleDelete,
  loading,
  handleDeleteIsReadNotifications,
  handleMarkNotificationsAsRead
}) => {
  const navigate = useNavigate();
  const { Text } = Typography;
  return (
    <>
      <AdnPageTitle title={title} />
      <AdnCard id={"adnCard"} loading={loading}>
        <Row justify="space-between" align="middle" style={{ marginBottom: "8px" }}>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }}>
            <p className="notificationResults" style={{ fontWeight: "bold", color: "var(--adngrey)", margin: "0" }}>{notifications.length} results</p>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }}>
            <Row className="notificationButtons">
              <Popconfirm
                className="notificationDeleteButton"
                title="Are you sure you want to delete the read notifications?"
                onConfirm={() => handleDeleteIsReadNotifications()}
              >
                <Button className="adn-outlined-button outlined-cancel" >Delete Read</Button>
              </Popconfirm>
              <Popconfirm
                title="Are you sure you want to mark all the notifications as read?"
                onConfirm={() => handleMarkNotificationsAsRead()}
              >
                <Button className="adn-outlined-button" >Mark all as Read</Button>
              </Popconfirm>
            </Row>
          </Col>
        </Row>
        <InfiniteScroll
          dataLength={notifications.length}
          next={loadMore}
          hasMore={notifications.length < totalRecords}
          endMessage={<Divider plain>There are no more notifications</Divider>}
          scrollableTarget="adnCard"
        >
          <AdnList
            data={notifications}
            renderItem={(item) => (
              <List.Item
                key={item.id}
                className={item.isRead ? "list-item" : "unread-list-item"}
              >
                <Row id={`notification${item.id}`} style={{ width: "100%" }}>
                  <Col
                    className="list-item-icon"
                    xs={{ span: 2 }}
                    sm={{ span: 2 }}
                    md={{ span: 2 }}
                    lg={{ span: 1 }}
                    xl={{ span: 1 }}
                    xxl={{ span: 1 }}
                  >
                    {NotificationTypes[item.notificationTypeId]}
                  </Col>
                  <Col
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate(item.link)}
                    xs={{ span: 24 }}
                    sm={{ span: 22 }}
                    md={{ span: 22 }}
                    lg={{ span: 23 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                  >
                    <Text ellipsis={true}>{item.description}</Text>
                  </Col>
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 20 }}
                    lg={{ span: 22 }}
                    xl={{ span: 9 }}
                    xxl={{ span: 9 }}
                  >
                    <Text style={{ fontSize: "12px" }}>
                      Notified at{" "}
                      {new Date(item.createdAt).toLocaleString("pt-PT")}
                    </Text>
                    {item.updatedAt != null ? (
                      <Text style={{ fontSize: "12px", marginLeft: "4%" }}>
                        {"Read at " +
                          new Date(item.updatedAt).toLocaleString("pt-PT")}
                      </Text>
                    ) : null}
                  </Col>
                  <Col style={{ marginRight: "1rem" }}>
                    {!item.isRead ? (
                      <Tooltip title="Mark as read">
                        <Eye
                          onClick={() => {
                            toggleIsRead(item.id);
                          }}
                          style={{ color: "var(--adnblue)" }}
                          width={16}
                          height={16}
                        />
                      </Tooltip>
                    ) : (
                      <Tooltip title="Mark as unread">
                        <EyeOff
                          onClick={() => {
                            toggleIsRead(item.id);
                          }}
                          style={{ color: "var(--adnblue)" }}
                          width={16}
                          height={16}
                        />
                      </Tooltip>
                    )}
                  </Col>
                  <Col style={{ marginLeft: "1%" }}>
                    <Tooltip title="Delete">
                      <X
                        onClick={() =>
                          adnYesNoModal(() => handleDelete(item.id))
                        }
                        style={{ color: "var(--adnred)" }}
                        width={16}
                        height={16}
                      />
                    </Tooltip>
                  </Col>
                </Row>
              </List.Item>
            )}
          />
        </InfiniteScroll>
      </AdnCard >
    </>
  );
};
